import { render, staticRenderFns } from "./AdminCategoryToolbar.vue?vue&type=template&id=2f687ae0&scoped=true"
import script from "./AdminCategoryToolbar.vue?vue&type=script&lang=js"
export * from "./AdminCategoryToolbar.vue?vue&type=script&lang=js"
import style0 from "./AdminCategoryToolbar.vue?vue&type=style&index=0&id=2f687ae0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f687ae0",
  null
  
)

export default component.exports